import { render } from "./FirmDashboard.vue?vue&type=template&id=07637954&scoped=true"
import script from "./FirmDashboard.vue?vue&type=script&lang=js"
export * from "./FirmDashboard.vue?vue&type=script&lang=js"

import "./FirmDashboard.vue?vue&type=style&index=0&id=07637954&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07637954"]])

export default __exports__